import { Pipe, PipeTransform } from '@angular/core';
import { IMigrationOrder } from '../models/IMigrations';

@Pipe({ name: 'subscriptionsPipe' })
export class SubscriptionsPipe implements PipeTransform {
  transform(order: IMigrationOrder, parameter: string) {
    let total = 0;
    if (
      order &&
      order.settings &&
      order.results &&
      order.settings.topics &&
      order.results.subscriptions
    ) {
      order.settings.topics.forEach((topic) => {
        total +=
          order.results.subscriptions[topic.id][topic.proMailingListId][
            parameter
          ];
      });
    }
    return total;
  }
}
